import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';

import ImageLightboxModal from './modals/ImageLightboxModal';
import JournalModalWrapper from './modals/JournalModalWrapper';
import MediaModalContent from './modals/MediaModalContent';
import RecordModal from './modals/RecordModal';
import SelectExerciseModal from './modals/SelectExerciseModal';
import MediaModalWrapper from './modals/MediaModalWrapper';

import {
  setCommentMediaTarget,
  setSubActiveReduxModal,
} from './ducks/journalActions';

const SUBMODAL_CONFIG = {
  'comment-record-image-modal': {
    Modal: RecordModal,
    Wrapper: JournalModalWrapper,
    wrapperProps: { backgroundColor: '#222' },
    modalProps: { isComment: true, mediaType: 'image' },
  },
  'comment-record-video-modal': {
    Modal: RecordModal,
    Wrapper: JournalModalWrapper,
    wrapperProps: { backgroundColor: '#222' },
    modalProps: { isComment: true, mediaType: 'video' },
  },
  'image-lightbox': {
    Modal: ImageLightboxModal,
    Wrapper: MediaModalWrapper,
    wrapperProps: {},
  },
  'play-message-video-modal': {
    Modal: MediaModalContent,
    Wrapper: MediaModalWrapper,
    wrapperProps: {},
  },
  'record-image-modal': {
    Modal: RecordModal,
    Wrapper: JournalModalWrapper,
    wrapperProps: { backgroundColor: '#222' },
    modalProps: { isComment: false, mediaType: 'image' },
  },
  'record-video-modal': {
    Modal: RecordModal,
    Wrapper: JournalModalWrapper,
    wrapperProps: { backgroundColor: '#222' },
    modalProps: { isComment: false, mediaType: 'video' },
  },
  'select-exercise-modal': {
    Modal: SelectExerciseModal,
    Wrapper: JournalModalWrapper,
    wrapperProps: {},
  },
};

const MainContainer = styled('main')``;

const SubModalHandler = () => {
  const { activeSubModal, messageMediaUrl } = useSelector((state) => state.journal.data);
  const dispatch = useDispatch();

  const closeSubModal = useCallback(() => {
    dispatch(setSubActiveReduxModal(''));
    dispatch(setCommentMediaTarget({}));
  }, [dispatch]);

  const subModalHandler = useCallback(() => {
    const config = SUBMODAL_CONFIG[activeSubModal];
    if (!config) return null;

    const {
      Modal,
      Wrapper,
      wrapperProps,
      modalProps: configModalProps = {},
    } = config;

    const modalProps = {
      onRequestClose: closeSubModal,
      ...configModalProps,
    };

    // Add mediaUrl for media modals
    if (activeSubModal === 'image-lightbox' || activeSubModal === 'play-message-video-modal') {
      modalProps.mediaUrl = messageMediaUrl;
    }

    return (
      <Wrapper isOpen onRequestClose={closeSubModal} {...wrapperProps}>
        <Modal {...modalProps} />
      </Wrapper>
    );
  }, [activeSubModal, closeSubModal, messageMediaUrl]);

  return <MainContainer>{subModalHandler()}</MainContainer>;
};

export default SubModalHandler;
